import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';
import { INews } from '../../../dashboard/shared/models/news';

@Injectable({
  providedIn: 'root'
})
export class CommitteeNewsService {

  baseUrl: string = `${environment.servicesUrl.committee}api/news`;


  constructor(
    private http: HttpClient,
  ) { }

  getNews(): Observable<IApiResponse<INews[]>> {
  return this.http
    .get<IApiResponse<INews[]>>(`${this.baseUrl}`);
  }
}
